export default __webpack_public_path__ + "images/be525f8f48ef8a865695c4f74eb4e65f-ballet.webp";